import {
  TableContainer,
  TableBody,
  TableCell,
  Table,
  TableRow,
} from "@material-ui/core";
import { PencilIcon, TrashIcon } from "App/Assets";
import {
  TableHeader,
  IconButtonDatatable,
  DatatablesFooter,
  ModalDeleteConfirm,
} from "App/Component/ui";
import { instance4 } from "App/constants";
import { useDatatables } from "App/hooks";
import {
  convertToValidPrice,
  defaultDateDisplay,
  defaultDateInputDisplay,
  defaultToastSuccess,
  formatNumber,
  isNull,
  today,
} from "App/utils/helpers";
import React, { useState, useContext } from "react";
import { stableSort, getComparator } from "App/Component/ui/datatable/utils";
import { FormContext } from "./context/FormContext";
import { requiredMsg } from "App/utils/validation";
import { LIST_URL_WAREHOUSE } from "utils/warehouse";
import { getUserName } from "App/utils/cookies";

export const urlCreatePembelian = LIST_URL_WAREHOUSE.pembelianLGS.add;
export const urlUpdatePembelian = LIST_URL_WAREHOUSE.pembelianLGS.update;
// export const urlAcceptPembelian = "/wmslogistik/pembelian/listTotalPembelian";
export const urlAcceptPembelian = LIST_URL_WAREHOUSE.pembelianLGS.accept;

export const urlGetPembelianById = LIST_URL_WAREHOUSE.pembelianLGS.getById;

export const urlGetPembelianItemByPembelianId =
  LIST_URL_WAREHOUSE.pembelianLGS.getBarangById;

export const urlCreateBarang = LIST_URL_WAREHOUSE.pembelianLGS.addBarang;
export const urlUpdateBarang = LIST_URL_WAREHOUSE.pembelianLGS.updateBarang;
export const urlDeleteBarang = LIST_URL_WAREHOUSE.pembelianLGS.deleteBarang;

export const urlGetGudang = LIST_URL_WAREHOUSE.masterGudangLGS.getGudangUtama;

export const STATUS_OPEN_DRAFT_PEMBELIAN = 0;

// TUTUP belum masuk ke inventory
export const STATUS_PROSES_PEMBELIAN = 1;

// ACCEPT masuk ke inventory
export const STATUS_SELESAI_PEMBELIAN = 2;

export const FORM_RESET_STATE_WMS_PEMBELIAN = {
  id: "",
  idgl: "",
  date: today(true),

  is_po: false,
  po_id: "",
  po_label: "Cari PO",

  gudang_id: null,
  gudang: "Pilih Gudang",

  user: getUserName(),

  supplier_id: null,
  supplier: "Pilih Supplier",

  faktur_no: "",
  faktur_tgl: today(),

  jatuhtempo_tgl: today(),
  kedatangan_tgl: today(),
  tagih_tgl: today(),
  kasbank_id: null,
  kasbank: "Pilih Kas Bank",
  coa_code:"",

  isOpenDraft: false,
  isProcess: false,

  status: STATUS_OPEN_DRAFT_PEMBELIAN,

  biayalain: 0,
  biayalain2: 0,

  ongkos: 0,
  ongkos2: 0,

  potongan: 0,
  potongan2: 0,

  tax: 0,
  tax2: 0,

  sisa: 0,
  is_changesellprice: true,
  bayar: 0,

  type: "create",

  jumlah: 0,
  pembayaran: 0,

  sub_disc: 0,
  sub_total: 0,
  sub_total2: 0,

  total: 0,
  total_jumlah: 0,
};

export const getPembelianById = async (id) => {
  try {
    const api = await instance4.get(`${urlGetPembelianById}/${id}`);
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data:
          res.data.length > 0
            ? res.data[0]
            : {
                biayalain: 0,
                ongkos: 0,
                potongan: 0,
                tax: 0,
                bayar: 0,
                sisa: 0,
              },
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const getPembelianItemByPembelianId = async (id) => {
  try {
    const api = await instance4.get(
      `${urlGetPembelianItemByPembelianId}/${id}`
    );
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res.data,
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    };
  }
};

export const deletePembelianListById = async (id) => {
  try {
    const api = await instance4.post(urlDeleteBarang, {
      id,
    });
    const res = api.data;
    if (res.status === 200) {
      return {
        state: true,
        data: res,
        message: "Berhasil menghapus pembelian list",
      };
    } else {
      return {
        state: false,
        message: res.message,
      };
    }
  } catch (error) {
    return {
      state: false,
      data: {},
      message: error?.response?.data?.message,
    };
  }
};

export const exportItemPembelianLogistik = async (id_pembelian) => {
  try {
    const api = await instance4.get(
      `/wmslogistik/pembelianItem/listItemByPembelianIdExport/${id_pembelian}`,
    )
    const res = api.data
    return {
      state: true,
      data: res.data,
      meta: res.meta,
    }
  } catch (error) {
    return {
      state: false,
      message: error?.response?.data?.message,
    }
  }
}



export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "id",
    disablePadding: true,
    label: "ID",
    align: "left",
  },
  {
    id: "namaBarang",
    disablePadding: false,
    label: "NAMA BARANG",
    align: "left",
    minWidth: "200px",
  },
  {
    id: "satuan",
    disablePadding: false,
    label: "SATUAN BELI",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "satuan",
    disablePadding: false,
    label: "SATUAN JUAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "qjb",
    disablePadding: false,
    label: "QJB",
    align: "left",
  },
  {
    id: "qjbhpp",
    disablePadding: false,
    label: "HARGA QJB HPP",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nobatch",
    disablePadding: false,
    label: "NO BATCH",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "expdate",
    disablePadding: false,
    label: "TANGGAL EXP",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "qty",
    disablePadding: false,
    label: "QTY",
    align: "left",
  },
  {
    id: "qty_total",
    disablePadding: false,
    label: "QTY TOTAL",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "harga_satuan",
    disablePadding: false,
    label: "HARGA",
    align: "left",
  },

  {
    id: "sub_jumlah",
    disablePadding: false,
    label: "SUB JUMLAH",
    align: "left",
    minWidth: "200px",
    sort: false,
  },
  {
    id: "disc",
    disablePadding: false,
    label: "DISC (%)",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "nilai_disc",
    disablePadding: false,
    label: "NILAI DISC",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "jumlah",
    disablePadding: false,
    label: "JUMLAH",
    align: "left",
  },
];

export const RenderListPembelian = ({
  classes,
  listPembelian,
  formBarang,
  setFormBarang,
  showModalBarang,
  setShowModalBarang,
  getListPembelian,
}) => {
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);

  const {
    page,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: listPembelian,
    orderByDefault: "namaBarang",
    orderByRow: ["namaBarang"],
  });
  const { formData } = useContext(FormContext);

  async function deleteList() {
    const res = await deletePembelianListById(formBarang.id);
    if (res.state) {
      defaultToastSuccess(res?.message);
      await getListPembelian(formData.id);
      setShowModalDeleteConfirm(false);
    } else {
      defaultToastSuccess(res?.message);
    }
  }

  const handleClickDelete = (row) => {
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
    setFormBarang({
      ...formBarang,
      id: row?.id,
    });
  };

  const handleClickUpdate = (row) => {
    setFormBarang({
      name: row?.namaBarang,
      id: row?.id,
      pembelian_id: row?.pembelian_id,
      barang_id: row?.barang_id,
      satuan_id: row?.satuan_id,
      satuanjual_id: row?.satuanjual_id,
      harga2: formatNumber(row?.harga_satuan),
      harga: row?.harga_satuan,
      qty: row?.qty,
      disc: row?.disc,
      nilai_disc: formatNumber(row?.nilai_disc),
      qjb: row?.qjb,
      hargaqjbhpp: convertToValidPrice(row.harga_satuan / row.qjb),
      nobatch: row?.nobatch,
      exired_date: isNull(row.exired_date)
        ? ""
        : defaultDateInputDisplay(row?.exired_date),
      remark: row?.remark,

      po_satuan_id: row?.po_satuan_id,
      po_qty: row?.po_qty,
      po_harga_satuan: formatNumber(row?.po_harga_satuan),
      po_disc: formatNumber(row?.po_disc),
      po_nilai_disc: formatNumber(row?.po_nilai_disc),
    });
    setShowModalBarang(!showModalBarang);
  };

  return (
    <>
      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}
      <p className='fw-600 mb-1 mt-1'>Data Transaki Pembelian</p>
      <TableContainer className='custom-scrollbar'>
        <Table
          className={classes.table}
          aria-labelledby='tableTitle'
          size={"medium"}
          aria-label='enhanced table'>
          <TableHeader
            order={order}
            orderBy={orderBy}
            onRequestSort={handleRequestSort}
            rowCount={length}
            headCells={headCells}
          />
          <TableBody>
            {stableSort(data, getComparator(order, orderBy))
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row, index) => {
                return (
                  <TableRow
                    hover
                    tabIndex={-1}
                    key={index}
                    style={{
                      backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                    }}>
                    <TableCell
                      component='th'
                      scope='row'
                      padding='none'
                      align='center'>
                      {index + 1}
                    </TableCell>

                    <TableCell
                      component='th'
                      scope='row'
                      padding='none'
                      align='center'>
                      {formData.status === STATUS_OPEN_DRAFT_PEMBELIAN && (
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "7px",
                          }}>
                          <IconButtonDatatable
                            onClick={() => handleClickUpdate(row)}>
                            <PencilIcon />
                          </IconButtonDatatable>

                          {!formData.is_po && (
                            <IconButtonDatatable
                              onClick={() => handleClickDelete(row)}>
                              <TrashIcon />
                            </IconButtonDatatable>
                          )}
                        </div>
                      )}
                    </TableCell>

                    <RenderTableCell row={row} />
                  </TableRow>
                );
              })}
            {listPembelian.length === 0 && (
              <TableRow>
                <TableCell align='center' colSpan={headCells.length}>
                  Tidak ada data
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <DatatablesFooter
        page={page}
        length={length}
        rowsPerPage={rowsPerPage}
        selectRows={[10, 20, 50, 100]}
        onPageChange={(page) => setPage(page - 1)}
        onSelectChange={(e) => setRowsPerPage(e.target.value)}
      />
    </>
  );
};

export const RenderTableCell = ({ row }) => {
  const subJumlah = row?.harga_satuan * row?.qty;
  const nilaiDisc = (parseFloat(row.disc) / 100) * subJumlah;
  const jumlah = subJumlah - nilaiDisc;

  return (
    <>
      <TableCell align='left'>{row.id}</TableCell>
      <TableCell align='left'>{row.namaBarang}</TableCell>
      <TableCell align='left'>{row.namaSatuan_beli}</TableCell>
      <TableCell align='left'>{row.namaSatuan_jual}</TableCell>
      <TableCell align='left'>{row.qjb}</TableCell>
      <TableCell align='left'>
        {formatNumber(row.harga_satuan / row.qjb)}
      </TableCell>
      <TableCell align='left'>{row.nobatch}</TableCell>
      <TableCell align='left'>
        {isNull(row.exired_date)
          ? "-"
          : defaultDateDisplay(row.exired_date, false)}
      </TableCell>

      <TableCell align='left'>{row.qty}</TableCell>
      <TableCell align='left'>{row.qty * row.qjb}</TableCell>

      <TableCell align='left'>{formatNumber(row.harga_satuan)}</TableCell>

      <TableCell align='left'>{formatNumber(subJumlah)}</TableCell>
      <TableCell align='left'>{row.disc}</TableCell>
      <TableCell align='left'>{formatNumber(nilaiDisc)}</TableCell>
      <TableCell align='left'>{formatNumber(jumlah)}</TableCell>
    </>
  );
};

export const validationInputPembelian = (formData) => {
  const errors = {};

  if (isNull(formData.gudang_id)) {
    errors["gudang_id"] = requiredMsg("Gudang");
  }

  if (isNull(formData.supplier_id)) {
    errors["supplier_id"] = requiredMsg("Supplier");
  }

  if (isNull(formData.kasbank_id)) {
    errors["kasbank_id"] = requiredMsg("Kas Bank");
  }

  return errors;
};
